var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentCollection)?_c('CollectionDetail',{attrs:{"collection":_vm.currentCollection}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }